module.exports = __webpack_public_path__ + "static/media/successpurchaseicon.17f2e9ff.svg";